import useApi from '../use-api';

import type { ISmsCampaignsSendData } from 'infrastructure/interfaces';

const apiUrl = 'core-2/patients/sms-campaign/progress';

export const useSendCampaigns = () => {
  const { loading, createData } = useApi();

  const sendCampaigns = async (data: ISmsCampaignsSendData) => {
    await createData(apiUrl, data);
  };

  return {
    loading,
    sendCampaigns,
  };
};
